const IMAGES = {
  r: 'assets/images/live-chat-rogers.png',
  f: 'assets/images/fido-live-chat.png',
  s: 'assets/images/fido-live-chat.png',
};

export function getConnectingToAgentImage(realm: string) {
  return IMAGES[realm];
}
